import usePosOrderTipAtom from "../atoms/usePosOrderTipAtom";

const usePosOrderTipHook = () => {
  const [tip, setTip] = usePosOrderTipAtom();
  const tipValue = parseFloat(tip === "-1" || !tip ? "0" : tip);

  return {
    tip,
    setTip,
    tipValue,
  };
};

export default usePosOrderTipHook;
